import type { ErrorEvent } from '@sentry/core'

const is40xError = (
  event: ErrorEvent,
  codes: string[],
  source: string
): boolean => {
  const exception = event?.exception?.values?.[0] ?? {}
  const { value = '' } = exception || {}
  return codes.some((code) => value.includes(source) && value.includes(code))
}

export default is40xError
